export default "__VITE_ASSET___gO5bWGw__"